import { z } from 'zod';

/////////////////////////////////////////
// NOTIFICATIONS DEVICES SCHEMA
/////////////////////////////////////////

export const NotificationsDevicesSchema = z.object({
  id: z.bigint(),
  city_id: z.number().int(),
  device_type: z.string(),
  platform_details: z.string(),
  platform_uid: z.string(),
  app_version: z.string(),
  registered_at: z.coerce.date(),
  heartbeat_at: z.coerce.date(),
  user_id: z.number().int().nullable(),
  token_id: z.number().int().nullable(),
})

export type NotificationsDevices = z.infer<typeof NotificationsDevicesSchema>

export default NotificationsDevicesSchema;
